import type { GetTypeAtPath, PathType } from '../TableBase.types'

export const getPropertyAtPath = <
  Data extends Record<string, unknown>,
  Path extends PathType<Data>
>(
  obj: Data,
  path: Path,
  maxDepth = 10
): GetTypeAtPath<Data, Path> => {
  if (path.startsWith('$')) return obj as GetTypeAtPath<Data, Path>

  let parts = path.split('.')
  let current = obj

  if (parts.length > maxDepth) {
    parts = parts.slice(0, maxDepth)
  }

  if (typeof current !== 'object') {
    return undefined as GetTypeAtPath<Data, Path>
  }

  try {
    for (const part of parts) {
      if (typeof current !== 'object') {
        return undefined as GetTypeAtPath<Data, Path>
      }

      if (current === null) {
        return undefined as GetTypeAtPath<Data, Path>
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      current = current[part] as any

      if (current === undefined) {
        return undefined as GetTypeAtPath<Data, Path>
      }
    }
  } catch (e) {
    return undefined as GetTypeAtPath<Data, Path>
  }

  return current as GetTypeAtPath<Data, Path>
}
